import { Controller } from "@hotwired/stimulus"

// Adds clickaway / Escape / focusout closing to a native <details> dropdown.
//
//   <details data-controller="dropdown" class="admin-overflow">
//     <summary>⋯</summary>
//     <div class="admin-overflow__menu">…</div>
//   </details>
export default class extends Controller {
  connect() {
    this.onDocumentClick = this.handleDocumentClick.bind(this)
    this.onKeydown = this.handleKeydown.bind(this)
    this.onFocusout = this.handleFocusout.bind(this)
    document.addEventListener("click", this.onDocumentClick, true)
    this.element.addEventListener("keydown", this.onKeydown)
    this.element.addEventListener("focusout", this.onFocusout)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick, true)
    this.element.removeEventListener("keydown", this.onKeydown)
    this.element.removeEventListener("focusout", this.onFocusout)
  }

  handleDocumentClick(event) {
    if (!this.element.hasAttribute("open")) return
    if (this.element.contains(event.target)) return
    this.close()
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return
    if (!this.element.hasAttribute("open")) return
    this.close()
    const summary = this.element.querySelector(":scope > summary")
    if (summary) summary.focus()
  }

  handleFocusout(event) {
    if (!this.element.hasAttribute("open")) return
    const next = event.relatedTarget
    if (next && this.element.contains(next)) return
    // Defer to the next tick so any in-flight click on a child (e.g. a
    // button_to "Sign out" form submit) has time to fire. On iOS Safari,
    // tapping a <button> doesn't focus it, so relatedTarget is null and
    // the active element is <body> — without this defer, we'd remove the
    // [open] attribute mid-tap and swallow the click.
    setTimeout(() => {
      if (!this.element.hasAttribute("open")) return
      const active = document.activeElement
      if (active && this.element.contains(active)) return
      this.close()
    }, 0)
  }

  close() {
    this.element.removeAttribute("open")
  }
}
